import React, {Fragment} from "react";
import TextInput from "../TextInput";
import classNames from "classnames";
import {hufRound} from "../../../utils/other";

export default class CashPayment extends React.Component {

    state = {
        cashback: "",
        total: 0
    };

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (this.props.option && this.props.total + "" !== "" + this.state.total) {
            this.setState({cashback: "", total: this.props.total});
        }
        if (this.props.option && (this.props.option.amount === undefined || this.props.option.amount === null || this.props.option.amount === "")) {
            let value = Math.max(0, this.props.total - (this.props.cost + this.props.rounding) - (this.props.overpay > 0 ? this.props.overpay : 0));
            value = hufRound(parseFloat(value || "0"));
            this.props.setFieldValue(String(this.props.optionIndex) + ".amount", value);
        }
    }

    render() {
        const amount = this.props.option.amount;
        const cost = this.props.cost;
        const total = this.props.total;
        return (
            <div className="payment cash-payment">
                <TextInput
                    type="number"
                    name="amount"
                    label={"Fizetendő"}
                    value={amount}
                    saveChanges={(name, value) => {
                        value = hufRound(parseFloat(value || "0"));
                        const bankcardOption = (this.props.value || []).find((v) => v.serviceprovider_type === "Bankcard");
                        if (bankcardOption) {
                            const bankcardOptionIndex = (this.props.value || []).findIndex((v) => v.serviceprovider_type === "Bankcard");
                            this.props.setFieldValue(String(bankcardOptionIndex) + ".amount", Math.max(0, Math.max(total - value, total - (cost - parseFloat(amount || "0")) - value)));
                        }
                        this.props.setFieldValue(String(this.props.optionIndex) + ".amount", value);
                    }}
                />
                <TextInput
                    type="number"
                    label={"Fizetve"}
                    value={this.state.cashback}
                    saveChanges={(name, cashback) => {
                        this.setState({cashback: parseFloat(cashback || "0") || 0});
                    }}
                />
                <TextInput
                    type="number"
                    label={"Visszajáró"}
                    disabled={true}
                    className={classNames({
                       "error": this.state.cashback ? (this.state.cashback || 0) - (this.props.option.amount || 0) < 0 : false
                    })}
                    value={this.state.cashback ? (this.state.cashback || 0) - (this.props.option.amount || 0) : ""}
                />
            </div>
        );
    }
}